document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('swiper-container.hero-slider-swiper');
  if (!sliders.length) return;

  function isPlaying (video) {
    return !video.paused && !video.ended && video.readyState > 2
  }

  sliders.forEach((swiperEl, index) => {
    const handleSlideChange = (event) => {
      const swiper = event?.target?.swiper ?? null;
      if (!swiper) return;
      const slides = swiper.slides || [];
      const activeSlide = slides[swiper.activeIndex];
      if (!activeSlide) return;
      activeSlide.querySelectorAll('video').forEach((video) => {
        try {
          if (isPlaying(video)) return;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(() => {
            });
          }
        } catch (e) {}
      });
    };

    const swiperBeforeSlideChange = (event, isInit = false) => {
      const swiper = event?.target?.swiper ?? null;
      if (!swiper) return;
      const slides = swiper.slides || [];
      slides.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          try {
            if (!isPlaying(video) || (isInit && index === 0)) return;
            video.pause();
          } catch (e) {}
        });
      });
    };

    swiperEl.addEventListener('swiperslidechange', (event) => {
      swiperBeforeSlideChange(event, false);
      handleSlideChange(event);
    });

    swiperEl.addEventListener('swiperslidechangetransitionend', handleSlideChange);
    swiperEl.addEventListener('swiperinit', (event) => {
      swiperBeforeSlideChange(event, true);
      handleSlideChange(event);
    });
  });
});
